// @flow
import React, { Component } from 'react';
import SectionCurrent from 'components/sections/SectionCurrent/SectionCurrent';
import { type SectionData } from 'store/modules/common';

type Props = {
  selected: ?SectionData,
};

class SectionCurrentContainer extends Component<Props> {
  render() {
    const { selected } = this.props;
    return (
      <SectionCurrent
        name={selected.title}
        count={selected.products.length}
        description={selected.description}
        thumbnail={selected.thumbnail}
      />
    );
  }
}

export default SectionCurrentContainer;



// WEBPACK FOOTER //
// ./src/containers/sections/SectionCurrentContainer.js